export default {
  setIcons: (state, icons) => {
    state.icons = icons;
  },
  setSelectItems: (state, items) => {
    state.selectItems = items;
  }
};
